import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { BREAKPOINT_EXTRA_SMALL, CX } from '../constants'
import Button from './button'
import Text from './text'
import Image from './image'
import Icon from './icon'

class PillItem extends React.PureComponent {
  setRef = (c) => {
    return false
    const { to, location, isActive } = this.props
    const isXS = window.innerWidth <= BREAKPOINT_EXTRA_SMALL
    const active = (isActive === true || (to === location.pathname && !location.search))

    this.item = c

    if (active && !!this.item && !!to && isXS) {
      const scrollEntirePageTo = [
        '/comments',
        '/photos',
        '/videos',
        '/listings',
        '/likes',
        '/bookmarks',
      ]
      const shouldScrollDirectly = !!scrollEntirePageTo.find((t) => to.indexOf(t) > -1)
      this.item.scrollIntoView({
        block: shouldScrollDirectly ? 'start' : 'nearest',
        inline: 'start',
      })
    }
  }

  render() {
    const {
      prependIcon,
      appendIcon,
      prependImage,
      title,
      to,
      onClick,
      location,
      isActive,
      isHidden,
      disabled
    } = this.props

    if (isHidden) return null

    // Combine state, props, location to make absolutely
    // sure of active status.
    const active = typeof isActive === 'boolean' ? isActive : (to === location.pathname && !location.search)

    const containerClasses = CX({
      d: 1,
      noUnderline: 1,
      text: 1,
      aiCenter: 1,
      jcCenter: 1,
      py7: 1,
      outlineNone: 1,
      outlineBrand_onFocus: !disabled,
      cursorPointer: 1,
      circle: 1,
      bgSecondary: !active,
      bgSecondaryDark_onHover: !active,
      bgBrand: active,
      animations_button: 1,
      mr5: 1,
      mb5: 1,
    })

    const textParentClasses = CX({
      d: 1,
      h100PC: 1,
      aiCenter: 1,
      jcCenter: 1,
      py2: 1,
      px5: 1,
      flexRow: 1,
    })

    const textOptions = {
      size: 'normal',
      color: active ? 'white' : 'secondary',
      weight: active ? 'bold' : 'medium',
      className: _s.px10,
      align: 'center',
      fullWeight: 'bold',
    }

    return (
      <Button
        onClick={onClick}
        className={containerClasses}
        to={to || undefined}
        noClasses
        buttonRef={this.setRef}
        isDisabled={disabled}
      >
        <span className={textParentClasses}>
          { !!prependImage && <Image src={prependImage} cfWidthPX='26px' width='26px' height='26px' className={[_s.circle, _s.ml10].join(' ')} /> }
          { !!prependIcon && <Icon id={prependIcon} size='10px' /> }
          <Text {...textOptions}>
            {title}
          </Text>
          { !!appendIcon && <Icon id={appendIcon} size='10px' className={[_s.circle, _s.pt2, _s.ml5, _s.mr10, _s.cSecondary].join(' ')} /> }
        </span>
      </Button>
    )
  }
}

PillItem.propTypes = {
  appendIcon: PropTypes.string,
  prependIcon: PropTypes.string,
  prependImage: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  to: PropTypes.string,
  isHidden: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default withRouter(PillItem)
